import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface ClearProductsDialogProps {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const ClearProductsDialog: React.FC<ClearProductsDialogProps> = ({
  open,
  onCancel,
  onContinue,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogContent sx={{ px: 3, pt: 2, pb: 1.5 }}>
        <Typography id="qa-clear-products-title" sx={{ color: 'rgba(0,0,0,0.87)', fontSize: '20px', fontWeight: 500, letterSpacing: '0.25px', lineHeight: '26px', mb: 2.5 }}>
          Some Products Unavailable
        </Typography>
        <Typography id="qa-clear-products-message" className="notice" sx={{ mb: 2.5 }}>
          Ship-to selection contributes to which products are available and
          products cannot be saved when changing locations. Would you like
          to remove all product(s) to select a new ship-to?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          id="qa-cancel-btn"
          variant="contained"
          onClick={onCancel}
          sx={{
            backgroundColor: '#0c479d',
            color: '#ffffff',
            '&:hover': { backgroundColor: '#083380' },
          }}
        >
          KEEP CURRENT SHIP-TO
        </Button>
        <Button
          id="qa-proceed-btn"
          variant="contained"
          onClick={onContinue}
          sx={{
            ml: 3,
            color: '#fe000c',
            backgroundColor: '#ffffff',
            '&:hover': { backgroundColor: '#f5f5f5' },
          }}
        >
          PROCEED AND REMOVE PRODUCTS
        </Button>
      </DialogActions>
    </Dialog>
  );
};
